<h1 i18n="admin|Logbook entries page title">Admin logbook entries</h1>

<app-paginated-table
  [columns]="columns"
  [query]="logbookEntriesGQL"
  [dataMapper]="dataMapper"
  (rowClick)="onLogbookEntryClick($event)"
  (selectionChange)="onSelectionChange($event)"
  (selectAllChange)="onSelectAllChange($event)"
  [orderKey]="orderBy?.key ?? null"
  [orderAsc]="orderBy?.asc ?? true"
  (orderByChange)="onOrderByChange($event)"
>
</app-paginated-table>

<p-toolbar>
  <ng-template #start>
    <p-button icon="pi pi-download" label="Export" (click)="onExportClick()" i18n="users|Export button"></p-button>
  </ng-template>
</p-toolbar>